import React from 'react';
import '../CSS/About.css';

const About: React.FC = () => {
    return (
        <div className="about-container">
            <div className="about-title">
                <h1>About Taswik</h1>
            </div>
            
            <div className="about-content">
                <div className="about-text-card">
                    <p>
                        Welcome to Taswik, where creativity meets professionalism. We are dedicated to bringing your vision to life through exceptional photography and visual storytelling.
                    </p>
                    <p>
                        Our team combines technical expertise with artistic vision to create stunning imagery that captures the essence of your brand, event, or special moments.
                    </p>
                    <p>
                    The leading company in the world of marketing and advertising in Lebanon & Ivory Coast , its goal is to develop businesses and present them in an ideal way for everyone
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;
